<template>
  <div class="dictionary-page">
    <el-card shadow="never" class="dictionary-types">
      <div slot="header" class="section-header"><strong>字典管理</strong><span>维护系统字典类型与数据项</span></div>
      <el-form :inline="true" size="small" class="query-form" @submit.native.prevent="searchTypes">
        <el-form-item label="名称"><el-input v-model="query.name" clearable placeholder="字典名称" maxlength="100" @keyup.enter.native="searchTypes" /></el-form-item>
        <el-form-item label="编码"><el-input v-model="query.code" clearable placeholder="字典编码" maxlength="80" @keyup.enter.native="searchTypes" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="query.status" clearable placeholder="全部"><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="searchTypes">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetTypes">重置</el-button></el-form-item>
      </el-form>
      <div class="table-actions"><el-button v-if="hasPermission('system:dict:add')" type="primary" size="small" icon="el-icon-plus" @click="openType()">新增字典</el-button><el-button v-if="hasPermission('system:dict:export')" size="small" icon="el-icon-download" :loading="exportingTypes" @click="exportTypes">导出</el-button></div>
      <el-alert v-if="typeError" :title="typeError" type="error" :closable="false" show-icon />
      <el-table ref="typeTable" v-loading="loadingTypes" :data="types" border stripe highlight-current-row row-key="id" @row-click="selectDictionary">
        <el-table-column prop="name" label="字典名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="code" label="字典编码" min-width="170" show-overflow-tooltip />
        <el-table-column label="状态" width="80" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag></template></el-table-column>
        <el-table-column label="内置" width="70" align="center"><template slot-scope="{ row }">{{ row.builtIn ? '是' : '否' }}</template></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column label="创建时间" width="170"><template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template></el-table-column>
        <el-table-column label="操作" width="215" fixed="right"><template slot-scope="{ row }"><el-button type="text" size="small" @click.stop="selectDictionary(row)">数据项</el-button><el-button v-if="hasPermission('system:dict:edit')" type="text" size="small" @click.stop="openType(row)">编辑</el-button><el-button v-if="hasPermission('system:dict:delete')" type="text" size="small" :disabled="row.builtIn" class="danger-text" @click.stop="removeType(row)">删除</el-button></template></el-table-column>
      </el-table>
      <el-pagination class="pagination" background :current-page.sync="query.pageNum" :page-size.sync="query.pageSize" :page-sizes="[10, 20, 50, 100]" :total="totalTypes" layout="total, sizes, prev, pager, next, jumper" @size-change="searchTypes" @current-change="fetchTypes" />
    </el-card>

    <el-card shadow="never" class="dictionary-items">
      <div slot="header" class="section-header"><strong>字典数据</strong><el-tag v-if="selected" size="small">{{ selected.name }} · {{ selected.code }}</el-tag><span v-else>请选择上方字典类型</span></div>
      <template v-if="selected">
        <el-form :inline="true" size="small" class="query-form" @submit.native.prevent="searchItems">
          <el-form-item label="标签"><el-input v-model="itemQuery.name" clearable placeholder="显示标签" maxlength="100" @keyup.enter.native="searchItems" /></el-form-item>
          <el-form-item label="字典值"><el-input v-model="itemQuery.code" clearable placeholder="字典值" maxlength="100" @keyup.enter.native="searchItems" /></el-form-item>
          <el-form-item label="状态"><el-select v-model="itemQuery.status" clearable placeholder="全部"><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
          <el-form-item><el-button type="primary" icon="el-icon-search" @click="searchItems">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetItems">重置</el-button></el-form-item>
        </el-form>
        <div class="table-actions"><el-button v-if="hasPermission('system:dict:add')" type="primary" size="small" icon="el-icon-plus" @click="openItem()">新增数据项</el-button><el-button v-if="hasPermission('system:dict:export')" size="small" icon="el-icon-download" :loading="exportingItems" @click="exportItems">导出</el-button></div>
        <el-alert v-if="itemError" :title="itemError" type="error" :closable="false" show-icon />
        <el-table v-loading="loadingItems" :data="items" border stripe row-key="id">
          <el-table-column prop="label" label="标签" min-width="150" show-overflow-tooltip />
          <el-table-column prop="value" label="字典值" min-width="150" show-overflow-tooltip />
          <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
          <el-table-column label="状态" width="90" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag></template></el-table-column>
          <el-table-column label="内置" width="70" align="center"><template slot-scope="{ row }">{{ row.builtIn ? '是' : '否' }}</template></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" width="140" fixed="right"><template slot-scope="{ row }"><el-button v-if="hasPermission('system:dict:edit')" type="text" size="small" @click="openItem(row)">编辑</el-button><el-button v-if="hasPermission('system:dict:delete')" type="text" size="small" :disabled="row.builtIn" class="danger-text" @click="removeItem(row)">删除</el-button></template></el-table-column>
        </el-table>
        <el-pagination class="pagination" background :current-page.sync="itemQuery.pageNum" :page-size.sync="itemQuery.pageSize" :page-sizes="[10, 20, 50, 100]" :total="totalItems" layout="total, sizes, prev, pager, next, jumper" @size-change="searchItems" @current-change="fetchItems" />
      </template>
      <el-empty v-else description="选择字典后，可维护标签、值、排序与状态" :image-size="72" />
    </el-card>

    <el-dialog :title="typeForm.id ? '编辑字典类型' : '新增字典类型'" :visible.sync="typeDialog" width="540px" :close-on-click-modal="false">
      <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="90px">
        <el-form-item label="字典名称" prop="name"><el-input v-model="typeForm.name" maxlength="100" show-word-limit /></el-form-item>
        <el-form-item label="字典编码" prop="code"><el-input v-model="typeForm.code" :disabled="typeForm.builtIn" maxlength="80" placeholder="例如：vehicle_category" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="typeForm.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">禁用</el-radio></el-radio-group></el-form-item>
        <el-form-item label="备注"><el-input v-model="typeForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="savingType" @click="typeDialog = false">取消</el-button><el-button type="primary" :loading="savingType" v-permission="typeForm.id ? 'system:dict:edit' : 'system:dict:add'" @click="saveType">保存</el-button></span>
    </el-dialog>

    <el-dialog :title="itemForm.id ? '编辑字典数据' : '新增字典数据'" :visible.sync="itemDialog" width="540px" :close-on-click-modal="false">
      <el-form ref="itemForm" :model="itemForm" :rules="itemRules" label-width="90px">
        <el-form-item label="字典类型"><el-input :value="selected && selected.name" disabled /></el-form-item>
        <el-form-item label="标签" prop="label"><el-input v-model="itemForm.label" maxlength="100" /></el-form-item>
        <el-form-item label="字典值" prop="value"><el-input v-model="itemForm.value" :disabled="itemForm.builtIn" maxlength="100" /></el-form-item>
        <el-form-item label="排序" prop="sortOrder"><el-input-number v-model="itemForm.sortOrder" :min="0" :max="999999" :precision="0" controls-position="right" /></el-form-item>
        <el-form-item label="状态"><el-radio-group v-model="itemForm.status"><el-radio :label="1">启用</el-radio><el-radio :label="0">禁用</el-radio></el-radio-group></el-form-item>
        <el-form-item label="备注"><el-input v-model="itemForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="savingItem" @click="itemDialog = false">取消</el-button><el-button type="primary" :loading="savingItem" v-permission="itemForm.id ? 'system:dict:edit' : 'system:dict:add'" @click="saveItem">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { hasPermission } from '@/utils/auth'
import { saveAs } from 'file-saver'

const emptyQuery = () => ({ name: '', code: '', status: null, pageNum: 1, pageSize: 10 })
const emptyType = () => ({ id: '', name: '', code: '', status: 1, remark: '', builtIn: false })
const emptyItem = () => ({ id: '', dictionaryId: '', label: '', value: '', sortOrder: 0, status: 1, remark: '', builtIn: false })
const required = label => [{ required: true, whitespace: true, message: `请输入${label}`, trigger: 'blur' }]

export default {
  name: 'DictionaryManage',
  data() {
    return {
      query: emptyQuery(), itemQuery: emptyQuery(), types: [], items: [], totalTypes: 0, totalItems: 0,
      selected: null, loadingTypes: false, loadingItems: false, typeError: '', itemError: '', typeRequestId: 0, itemRequestId: 0,
      typeDialog: false, itemDialog: false, savingType: false, savingItem: false, exportingTypes: false, exportingItems: false,
      typeForm: emptyType(), itemForm: emptyItem(),
      typeRules: { name: required('字典名称'), code: required('字典编码') },
      itemRules: { label: required('标签'), value: required('字典值'), sortOrder: [{ required: true, type: 'number', message: '请输入排序', trigger: 'change' }] }
    }
  },
  created() { this.fetchTypes() },
  beforeDestroy() { this.typeRequestId++; this.itemRequestId++ },
  methods: {
    hasPermission,
    formatTime(value) { return value ? String(value).replace('T', ' ').slice(0, 19) : '-' },
    searchTypes() { this.query.pageNum = 1; this.fetchTypes() },
    resetTypes() { this.query = emptyQuery(); this.fetchTypes() },
    searchItems() { this.itemQuery.pageNum = 1; this.fetchItems() },
    resetItems() { this.itemQuery = emptyQuery(); this.fetchItems() },
    async fetchTypes() {
      const requestId = ++this.typeRequestId
      this.loadingTypes = true
      this.typeError = ''
      try {
        const response = await request.get('/webserver/system/dictionaries', { params: this.query })
        if (requestId !== this.typeRequestId) return
        this.types = response.data.items
        this.totalTypes = response.data.total
        if (!this.types.length && this.query.pageNum > 1) { this.query.pageNum--; return this.fetchTypes() }
        const selected = this.types.find(row => this.selected && row.id === this.selected.id) || this.types[0] || null
        if (selected) {
          if (!this.selected || this.selected.id !== selected.id) this.selectDictionary(selected)
          else this.selected = selected
          this.$nextTick(() => this.$refs.typeTable && this.$refs.typeTable.setCurrentRow(selected))
        } else { this.selected = null; this.items = []; this.totalItems = 0; this.itemRequestId++ }
      } catch (error) {
        if (requestId === this.typeRequestId) this.typeError = error.msg || '读取字典失败，请重试'
      } finally { if (requestId === this.typeRequestId) this.loadingTypes = false }
    },
    selectDictionary(row) {
      if (!row || (this.selected && this.selected.id === row.id)) return
      this.selected = row
      this.itemQuery = emptyQuery()
      this.items = []
      this.totalItems = 0
      this.fetchItems()
    },
    async fetchItems() {
      if (!this.selected) return
      const requestId = ++this.itemRequestId
      const dictionaryId = this.selected.id
      this.loadingItems = true
      this.itemError = ''
      try {
        const response = await request.get(`/webserver/system/dictionaries/${dictionaryId}/items`, { params: this.itemQuery })
        if (requestId !== this.itemRequestId) return
        this.items = response.data.items
        this.totalItems = response.data.total
        if (!this.items.length && this.itemQuery.pageNum > 1) { this.itemQuery.pageNum--; return this.fetchItems() }
      } catch (error) {
        if (requestId === this.itemRequestId) this.itemError = error.msg || '读取数据项失败，请重试'
      } finally { if (requestId === this.itemRequestId) this.loadingItems = false }
    },
    openType(row) {
      this.typeForm = row ? { ...row } : emptyType()
      this.typeDialog = true
      this.$nextTick(() => this.$refs.typeForm && this.$refs.typeForm.clearValidate())
    },
    openItem(row) {
      if (!this.selected) return
      this.itemForm = row ? { ...row } : { ...emptyItem(), dictionaryId: this.selected.id }
      this.itemDialog = true
      this.$nextTick(() => this.$refs.itemForm && this.$refs.itemForm.clearValidate())
    },
    saveType() {
      this.$refs.typeForm.validate(async valid => {
        if (!valid || this.savingType) return
        this.savingType = true
        const { id, name, code, status, remark } = this.typeForm
        try {
          if (id) await request.put(`/webserver/system/dictionaries/${id}`, { name, code, status, remark })
          else await request.post('/webserver/system/dictionaries', { name, code, status, remark })
          this.$message.success('字典已保存')
          this.typeDialog = false
          await this.fetchTypes()
        } catch (error) { this.$message.error(error.msg || '保存字典失败') }
        finally { this.savingType = false }
      })
    },
    saveItem() {
      this.$refs.itemForm.validate(async valid => {
        if (!valid || this.savingItem) return
        this.savingItem = true
        const { id, dictionaryId, label, value, sortOrder, status, remark } = this.itemForm
        try {
          if (id) await request.put(`/webserver/system/dictionary-items/${id}`, { dictionaryId, label, value, sortOrder, status, remark })
          else await request.post('/webserver/system/dictionary-items', { dictionaryId, label, value, sortOrder, status, remark })
          this.$message.success('数据项已保存')
          this.itemDialog = false
          await this.fetchItems()
        } catch (error) { this.$message.error(error.msg || '保存数据项失败') }
        finally { this.savingItem = false }
      })
    },
    async removeType(row) {
      try {
        await this.$confirm(`确认删除字典“${row.name}”吗？字典下存在数据项时无法删除。`, '删除字典', { type: 'warning' })
        await request.delete(`/webserver/system/dictionaries/${row.id}`)
        this.$message.success('字典已删除')
        await this.fetchTypes()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '删除失败') }
    },
    async removeItem(row) {
      try {
        await this.$confirm(`确认删除数据项“${row.label}”吗？`, '删除数据项', { type: 'warning' })
        await request.delete(`/webserver/system/dictionary-items/${row.id}`)
        this.$message.success('数据项已删除')
        await this.fetchItems()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '删除失败') }
    },
    async exportTypes() {
      this.exportingTypes = true
      try { await this.download('/webserver/system/dictionaries/export', this.query, '字典类型.xlsx') }
      catch (error) { this.$message.error(error.msg || '导出字典失败') }
      finally { this.exportingTypes = false }
    },
    async exportItems() {
      if (!this.selected) return
      this.exportingItems = true
      try { await this.download(`/webserver/system/dictionaries/${this.selected.id}/items/export`, this.itemQuery, '字典数据.xlsx') }
      catch (error) { this.$message.error(error.msg || '导出数据项失败') }
      finally { this.exportingItems = false }
    },
    async download(url, params, filename) {
      const response = await request.get(url, { params, responseType: 'blob' })
      if (response.data.type.includes('json')) {
        const body = JSON.parse(await response.data.text())
        throw { msg: body.msg || '导出失败' }
      }
      saveAs(response.data, filename)
    }
  }
}
</script>

<style scoped>
.dictionary-page { padding: 18px; background: #f4f6f9; min-height: 100%; box-sizing: border-box; }
.dictionary-types, .dictionary-items { margin-bottom: 18px; }
.section-header { display: flex; align-items: center; gap: 14px; }
.section-header strong { font-size: 16px; }
.section-header span { color: #909399; font-size: 13px; }
.query-form .el-input { width: 170px; }
.query-form .el-select { width: 120px; }
.table-actions { margin-bottom: 14px; }
.pagination { margin-top: 18px; text-align: right; }
.danger-text:not(.is-disabled) { color: #f56c6c; }
.el-alert { margin-bottom: 12px; }
</style>
